/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import {useUserContext} from "../../../contexts/userContext";

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as EditSvg } from '../../../resources/images/edit.svg';

/* Styles */
import styles from "./styles";


const EditCitiPCANsModal = ({showEditPcanModal, setShowEditPcaModal, primaryPCAN, auPCAN, userId, setPrimaryField, setAuPCANField, entityPCANLimit}) => {

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      className={classes.updateCitiPcanModal}
      showModal={ showEditPcanModal }
      setShowModal={ setShowEditPcaModal }
      modalIcon={ <EditSvg /> }
      modalTitle={ <FormattedMessage id="editCitiPCANsModal.title" /> }
      modalDescription={<FormattedMessage id="editCitiPCANsModal.description" />}
      modalContent={
        <Content
          setShowModal={ setShowEditPcaModal }
          primaryPCAN={primaryPCAN}
          auPCAN={auPCAN}
          userId={userId}
          setPrimaryField={setPrimaryField}
          setAuPCANField={setAuPCANField}
          entityPCANLimit={entityPCANLimit}
        /> }
      dataTestId="editCitiPcanModal"
    />
  )
}

export default EditCitiPCANsModal;